export const enecoProgressIndicatorTokensColors = {
  progressIndicatorItemDefault: '{{ neutralColors.neutral400 }}',
  progressIndicatorItemDisabled: '{{ neutralColors.neutral300 }}',
};
